import React from 'react';
import { CouponAssessment, AssessmentField } from '../../../../../types/generated.types';
import StarRating from './StarRating';
import FieldWrapper from '../../../../../common/FieldWrapper';
import AutoResizeTextarea from '../../../../../common/AutoResizeTextarea';

interface CouponAssessmentSelectableProps {
  assessment?: CouponAssessment | null;
  selectedFields: AssessmentField[];
  onToggleField: (field: AssessmentField) => void;
}

const CouponAssessmentSelectable: React.FC<CouponAssessmentSelectableProps> = ({ assessment, selectedFields, onToggleField }) => {

  const isSelected = (field: AssessmentField, selected: AssessmentField[]) =>
    selected.includes(field);


  const fieldClass = (field: AssessmentField) =>
    `assessment-field-selectable ${isSelected(field, selectedFields) ? 'selected' : ''}`;

  return (
    <main>
      <FieldWrapper name="rating" title="">
        <div className={`flex star-rating-container ${fieldClass(AssessmentField.Rating)}`}
          onClick={() => onToggleField(AssessmentField.Rating)}
        >
          <StarRating rating={assessment?.rating ?? 0} hideText />
          <input
            type="number"
            min="0"
            max="5"
            step="0.1"
            value={assessment?.rating !== undefined && assessment?.rating !== null ? assessment.rating : ''}
            placeholder="4.5"
            style={{ maxWidth: 'max-content' }}
            className="rating-input"
            title="Betyg (0-5)"
            readOnly
          />
          /5
        </div>

      </FieldWrapper>

      <FieldWrapper name="motivation" title="" x2
        className={fieldClass(AssessmentField.Motivation)}
        onClick={() => onToggleField(AssessmentField.Motivation)}
      >
        <input
          type="text"
          value={assessment?.motivation || ''}
          placeholder="Motivering sammanfattad i en rubrik med säljande ton för annonsörerna"
          title="Motivering"
          readOnly
        />
      </FieldWrapper>

      <div className="assessment-columns flex gap-2 mt">
        <FieldWrapper name="expectedEffect" title="FÖRVÄNTAD EFFEKT"
          className={fieldClass(AssessmentField.ExpectedEffect)}
          onClick={() => onToggleField(AssessmentField.ExpectedEffect)}
        >
          <AutoResizeTextarea
            value={assessment?.expectedEffect || ''}
            onChange={() => { }}
            placeholder="AI-genererad bedömning, ofta låg - hög, smal - bred + kommentar"
            rows={3}
            title="Förväntad effekt"
            readOnly
          />
        </FieldWrapper>

        <FieldWrapper name="profitability" title="LÖNSAMHET"
          className={fieldClass(AssessmentField.Profitability)}
          onClick={() => onToggleField(AssessmentField.Profitability)}
        >
          <AutoResizeTextarea
            value={assessment?.profitability || ''}
            onChange={() => { }}
            placeholder="AI-genererad bedömning, ofta låg - hög, smal - bred + kommentar"
            rows={3}
            title="Lönsamhet"
            readOnly

          />
        </FieldWrapper>

        <FieldWrapper name="targetGroupAdaptation" title="MÅLGRUPPSANPASSNING"
          className={fieldClass(AssessmentField.TargetGroupAdaptation)}
          onClick={() => onToggleField(AssessmentField.TargetGroupAdaptation)}
        >
          <AutoResizeTextarea
            value={assessment?.targetGroupAdaptation || ''}
            onChange={() => { }}
            placeholder="AI-genererad bedömning, ofta låg - hög, smal - bred + kommentar"
            rows={3}
            title="Målgruppsanpassning"
            readOnly
          />
        </FieldWrapper>
      </div>
    </main>

  );
}

export default CouponAssessmentSelectable;

